import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackVersionDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackVersionDeleted = useCallback(() => {
    track(`Version deleted`);
  }, [track]);

  return { trackVersionDeleted };
};
